export default "__VITE_ASSET__XI9$jzg___"